import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTenantConigrationApi } from '@apis/api-helper';
import { Toast } from '@common-web';
import { getErrorString } from '@utils/utils';

const initialState = {
  success: false,
  tenant: {},
  loading: false,
};

export const fetchTenantConfiguration = createAsyncThunk('tenant/configuration', async (params = '') => {
  try {
    const response = await getTenantConigrationApi(params);
    return response;
  } catch (err) {
    Toast.error(getErrorString(err));
    return [];
  }
});

const TenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchTenantConfiguration.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTenantConfiguration.fulfilled, (state, action) => {
        state.tenant = action?.payload?.tenant;
        state.loading = false;
        state.success = true;
      });
  },
});

export default TenantSlice.reducer;
